'use strict';

var React = require('react');
var LabelParts = require('../common/LabelParts');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');

/**
 * 上下文操作栏
 */
var ContextActionBar = React.createClass({

  render: function () {
    var size = styleHelper.getSize(this.props);
    var backgroundStyle = {
      width: size.width,
      height: size.height,
      backgroundColor: styleHelper.getBackgroundColor(this.props)
    };

    var margin = 8;
    var imgWidth = 32;

    var pasteImgStyle = {
      position: 'absolute',
      top: (size.height - imgWidth) / 2,
      width: imgWidth,
      height: imgWidth,
      right: margin
    };

    var cutImgStyle = {
      position: 'absolute',
      top: (size.height - imgWidth) / 2,
      width: imgWidth,
      height: imgWidth,
      right: margin * 2 + imgWidth
    };

    var selectAllImgStyle = {
      position: 'absolute',
      top: (size.height - imgWidth) / 2,
      width: imgWidth,
      height: imgWidth,
      right: margin * 3 + imgWidth * 2
    };

    var checkMarkStyle = {
      position: 'absolute',
      top: (size.height - imgWidth) / 2,
      width: imgWidth,
      height: imgWidth,
      left: margin
    };

    var lineStyle = {
      position: 'absolute',
      top: (size.height - imgWidth) / 2,
      width: 2,
      height: imgWidth,
      left: margin * 2 + imgWidth,
      backgroundColor: '#808080'
    };

    var textStyle = {
      position: 'absolute',
      top: (size.height - imgWidth) / 2,
      width: size.width - (margin * 3 + imgWidth + 2) - (margin * 4 + imgWidth * 3),
      height: imgWidth,
      lineHeight: imgWidth + 'px',
      left: margin * 3 + imgWidth + 2,
      overflow:'hidden',
      fontFamily : this.props.textFontFamily || decodeURIComponent(this.props.font.family)
    };

    return (<div style={backgroundStyle}>
      <img src={assetsHelper.getComponentAsset('CheckMark')} style={checkMarkStyle}/>
      <div style={lineStyle}></div>
      <LabelParts {...this.props} partStyle={textStyle}/>

      <img src={assetsHelper.getComponentAsset('AndroidSelectedAll')} style={selectAllImgStyle}/>
      <img src={assetsHelper.getComponentAsset('AndroidCut')} style={cutImgStyle}/>
      <img src={assetsHelper.getComponentAsset('AndroidPaste')} style={pasteImgStyle}/>
    </div>);
  }
});

module.exports = ContextActionBar;



// WEBPACK FOOTER //
// ./src/views/Components/ContextActionBar.jsx